export default __webpack_public_path__ + "src/fonts/TheMixC5-9_Black.woff";